import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_FirstScreen = _resolveComponent("FirstScreen")!
  const _component_CoreValues = _resolveComponent("CoreValues")!
  const _component_ProductsShowcase = _resolveComponent("ProductsShowcase")!
  const _component_Advantage = _resolveComponent("Advantage")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "global-background" }, [
      _createElementVNode("div", { class: "gradient-overlay" }),
      _createElementVNode("div", { class: "dynamic-texture" })
    ], -1)),
    _createVNode(_component_Header),
    _createVNode(_component_FirstScreen),
    _createVNode(_component_CoreValues),
    _createVNode(_component_ProductsShowcase),
    _createVNode(_component_Advantage),
    _createVNode(_component_Footer)
  ]))
}